<template>        
        
        <form-helper >
            <div slot="form-header">

                <h4 class="grey--text text--darken-2">Marken & Adressen</h4>                                   

            </div>

            <div slot="form-fields">


            <v-layout row>
                <v-flex xs12>
                    <marken-select></marken-select>
                </v-flex>
            </v-layout>  
            <v-divider class="my-4"></v-divider>
            <v-layout row>
                <v-flex xs12>
                    <adressen-select></adressen-select>
                </v-flex>
            </v-layout>    
               
            </div>
            <div slot="form-commands" >

                <v-btn icon v-on:click="submitted">
                    <v-icon x-large class="green--text">done</v-icon>
                </v-btn>                        


                <router-link to="/firmen" exact>
                    <v-btn icon>
                        <v-icon x-large class="red--text">close</v-icon>
                    </v-btn>
                </router-link>

            </div>
            
        </form-helper>
       
</template>

<script>
import formHelper from '../formHelper.vue'
import markenSelect from '../shared/markenSelect.vue'
import adressenSelect from '../shared/adressenSelect.vue'

export default {
    components: {
        'form-helper': formHelper,
        'marken-select': markenSelect,
        'adressen-select': adressenSelect
    },
    data() {
        return {
            id: this.$route.params.id,            
        };
    },
    mounted() {
        
      this.$store.dispatch('setAdressen').then((response)=>{
            this.$store.dispatch('setMarken')
        })  
    },
    computed: {
        fa: function() {
            return this.$store.getters.firma
        },
         loading: function() {
            return this.$store.getters.loading
        },
        basePath: function() {
            return this.$axios.defaults.baseURL
        }, 
    },
    
    methods: {
        submitted: function() {
                        
            this.$emit('submitted', this.fa)
        },
        
        detach: function(propname, index) {
            
           if(this.fa.hasOwnProperty(propname) && this.fa[propname].constructor === Array) {
               this.fa[propname].splice(index,1);
           };
            
            
            
        },
        
        markenlogo: function(path) {
            return this.basePath + 'storage/logos/' + path;
        },       
    },
    
    
}
    
</script>

<style>
    
    .dragArea {
        background-color: #292929;
        min-height: 40px;
    }
    img.dragLogo {
        max-height: 40px;
        border-radius: 0%;
        max-width: 500px;
        width: auto;
    }
</style>


// WEBPACK FOOTER //
// editFirmen_2.vue?950ec70e